import { maxWidth600 } from "themes/default/breakpoints"
export const styles = {
  messageComment: {
    py: 1.25,
    flexWrap: "nowrap",
    mb: 0,
  },
  messageCommentStudent: {
    width: `calc(95% - 70px)`,
    ml: `calc(5% + 70px)`,
    [maxWidth600]: {
      width: "100%",
      ml: 0,
    },
  },
  messageProfileAvatar: {
    float: "left",
    width: 64,
    height: "100%",
  },
  messageProfileAvatarStudent: {
    width: 42,
    height: 42,
    order: 2,
    ml: 1.25,
  },
  commentData: {
    float: "left",
    width: `calc(100% - 64px)`,
    position: "relative",
    borderRadius: "2rem",
    p: ".5rem 2rem",
    boxShadow: "rgba(60,64,67,.3) 0 1px 2px 0,rgba(60,64,67,.15) 0 1px 3px 1px",
  },
  commentDataStudent: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: "20px",
    marginLeft: 0.625,
    order: 1,
  },
  commentDataTeacher: {
    borderRadius: 1.25,
    p: 1.875,
  },
  commentUser: (theme) => ({
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: 14,
  }),
  commentDate: (theme) => ({
    fontSize: 12,
    color: theme.palette.common.black,
    opacity: 0.87,
    pt: "1px",
  }),
  comment: {
    wordBreak: "break-word",
  },
}
